import { Action, createReducer, on } from '@ngrx/store';
import {
  agentIsCreatedAction,
  removeRecentAgentAction
} from 'src/app/actions/agent';

export interface AgentState {
  agents: any[];
  recentAgent?: any | null;
}

export const initialState: AgentState = {
  agents: [],
  recentAgent: null
};

const _agentReducer = createReducer(
  initialState,
  on(agentIsCreatedAction, (state, { newAgent }) => ({
    ...state,
    agents: [...state.agents, newAgent],
    recentAgent: newAgent
  })),
  on(removeRecentAgentAction, state => ({
    ...state,
    recentAgent: null
  }))
);

export function AgentReducer(state: AgentState | undefined, action: Action) {
  return _agentReducer(state, action);
}
